import { useNavigate } from 'react-router-dom';

interface MergeCompaniesButtonProps {
    disabled: boolean; 
    selectedRows: number[];
}

function MergeCompaniesButton({ disabled, selectedRows }: MergeCompaniesButtonProps) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (!disabled && selectedRows.length > 0) {
            navigate('/companies/merge', { state: { selectedCompanies: selectedRows } });
        }
    };

    return (
        <button
            onClick={handleClick}
            disabled={disabled}
            className={`bg-button-blue hover:bg-color-cai-blue text-white font-semibold py-2 px-4 rounded-md text-sm mt-2 md:mt-0 ${
                disabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
        >
            Merge Companies
        </button>
    );
}

export default MergeCompaniesButton;
